import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import { NavHashLink } from 'react-router-hash-link';
import { connect } from 'react-redux';
import { format } from 'date-fns';

const EMAILLIST = 9

function ArticleCard({
  article,
  country,
}) {

  const {
    id,
    name,
    category,
    bannerURL,
    slug,
    // country,
    excerpt,
    author,
    authorSlug,
    duration,
    coverImage
  } = article

  const prefix = `${country}/a`

  return (

    <div className="flex flex-col rounded-lg shadow-lg overflow-hidden">
      <div className="flex-shrink-0">
        <Link to={`/${prefix}/${slug}`} className="hover:underline">
          <img className="h-48 w-full object-cover" src={`${coverImage}`} alt=""/>
        </Link>
      </div>
      <div className="flex-1 bg-white p-6 flex flex-col justify-between">
        <div className="flex-1">
          <p className="text-sm leading-5 font-medium text-orange-600">
            {/* <Link to={`/${prefix}/${slug}`} className="hover:underline">
              {category}
            </Link> */}
          </p>
          <Link to={`/${prefix}/${slug}`} className="block">
            <h3 className="mt-2 text-xl leading-7 font-semibold text-gray-900">
              {name}
            </h3>
            <p className="mt-3 text-base leading-6 text-gray-500">
              {excerpt}
            </p>
          </Link>
        </div>
        <div className="mt-6 sm:flex items-center justify-between">
          <div className="flex-shrink-0 flex">
            <div className="flex-shrink-0">
              {authorSlug &&
                <Link to={`/${prefix}/${slug}`}>
                  <img className="h-10 w-10 rounded-full"
                    src={require(`../../assets/images/team/${authorSlug}.jpg`).default}
                    alt=""
                    style={{
                      objectPosition: "center",
                      objectFit: "cover"
                    }}
                  />
                </Link>
              }
            </div>
            <div className="ml-3">
              <p className="text-sm leading-5 font-medium text-gray-900">
                <Link to={`/${prefix}/${slug}`} className="hover:underline">
                  {author}
                </Link>
              </p>
              <div className="flex text-sm leading-5 text-gray-500">
                <span>
                  {duration} min read
                </span>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0 flex mt-2 sm:mt-0">
            <Link to={`/${prefix}/${slug}`}
              className="text-center w-full px-5 py-3 border border-transparent text-base leading-3 font-medium rounded-md text-white bg-orange-500 hover:text-orange-100 hover:bg-orange-600 transition duration-150 ease-in-out sm:w-auto"
            >
              Read More
            </Link>
          </div>
        </div>
      </div>
    </div>

  );
}

const mapStateToProps = (state, ownProps) => {

  const currentCourse = ownProps.courses

  // const isSubscribed = state.payment.services && state.payment.services.find(s => s.service == currentCourse.id)



  return {
    // isSubscribed,
  }
}

const mapDispatchToProps = dispatch => ({

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArticleCard) 
